import { Notification } from "@/components/admin/notification";
import { useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const ConfirmationRequired = () => {
  const translate = useTranslate();
  const { darkModeLogo: logo, title } = useConfigurationContext();

  return (
    <div className="h-screen p-8">
      <div className="flex items-center gap-4">
        <img src={logo} alt={title} width={24} className="h-8 w-auto" />
        <h1 className="text-xl font-semibold">{title}</h1>
      </div>
      <div className="h-full text-center">
        <div className="max-w-sm mx-auto h-full flex flex-col justify-center gap-4">
          {/* design-system.md section 4/6: borderless white card on the
              paper background, no other frame around the message. */}
          <Card>
            <CardContent className="space-y-4">
              <h1 className="text-2xl font-bold">
                {translate("crm.auth.welcome_title", {
                  _: "Welcome to Atomic CRM",
                })}
              </h1>
              <p className="text-base">
                {translate("crm.auth.confirmation_required", {
                  _: "Please follow the link we just sent you by email to confirm your account.",
                })}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
      <Notification />
    </div>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
